import { render, staticRenderFns } from "./AppFifthScreen.vue?vue&type=template&id=7939208f&scoped=true"
import script from "./AppFifthScreen.vue?vue&type=script&lang=js"
export * from "./AppFifthScreen.vue?vue&type=script&lang=js"
import style0 from "./AppFifthScreen.vue?vue&type=style&index=0&id=7939208f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7939208f",
  null
  
)

export default component.exports